import { render, staticRenderFns } from "./InputTextAreaField.vue?vue&type=template&id=67664b42&"
import script from "./InputTextAreaField.vue?vue&type=script&lang=js&"
export * from "./InputTextAreaField.vue?vue&type=script&lang=js&"
import style0 from "./InputTextAreaField.vue?vue&type=style&index=0&id=67664b42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports